var map = {
	"./heroImage": 3866,
	"./heroImage.tsx": 3866,
	"./meleeHeroes": 3130,
	"./meleeHeroes.json": 3130,
	"./meleeHeroesImages/bowser.png": 2094,
	"./meleeHeroesImages/cf.png": 9767,
	"./meleeHeroesImages/dk.png": 4467,
	"./meleeHeroesImages/doppelganger.png": 2508,
	"./meleeHeroesImages/drmario.png": 620,
	"./meleeHeroesImages/falco.png": 1233,
	"./meleeHeroesImages/fox.png": 3249,
	"./meleeHeroesImages/ganon.png": 3111,
	"./meleeHeroesImages/iceclimbers.png": 8678,
	"./meleeHeroesImages/kirby.png": 4459,
	"./meleeHeroesImages/link.png": 7160,
	"./meleeHeroesImages/logo.png": 6693,
	"./meleeHeroesImages/luigi.png": 7208,
	"./meleeHeroesImages/mario.png": 8090,
	"./meleeHeroesImages/marth.png": 5086,
	"./meleeHeroesImages/mewtwo.png": 437,
	"./meleeHeroesImages/mrgame.png": 9396,
	"./meleeHeroesImages/ness.png": 1605,
	"./meleeHeroesImages/peach.png": 4433,
	"./meleeHeroesImages/pichu.png": 543,
	"./meleeHeroesImages/pika.png": 7145,
	"./meleeHeroesImages/puff.png": 2797,
	"./meleeHeroesImages/roy.png": 7988,
	"./meleeHeroesImages/samus.png": 1027,
	"./meleeHeroesImages/sheik.png": 4440,
	"./meleeHeroesImages/unpicked_icon.png": 8233,
	"./meleeHeroesImages/yoshi.png": 6600,
	"./meleeHeroesImages/younglink.png": 9078,
	"./meleeHeroesImages/zelda.png": 7250,
	"./ultimateHeroes": 8929,
	"./ultimateHeroes.json": 8929,
	"./ultimateHeroesImages/bayonetta.png": 5502,
	"./ultimateHeroesImages/bowser.png": 4085,
	"./ultimateHeroesImages/bowserjr.png": 7105,
	"./ultimateHeroesImages/cf.png": 1504,
	"./ultimateHeroesImages/cloud.png": 4612,
	"./ultimateHeroesImages/corrin.png": 1916,
	"./ultimateHeroesImages/darkpit.png": 140,
	"./ultimateHeroesImages/dedede.png": 1310,
	"./ultimateHeroesImages/diddy.png": 3585,
	"./ultimateHeroesImages/donkeykong.png": 168,
	"./ultimateHeroesImages/doppelganger.png": 5271,
	"./ultimateHeroesImages/drmario.png": 8321,
	"./ultimateHeroesImages/duckhunt.png": 3127,
	"./ultimateHeroesImages/falco.png": 708,
	"./ultimateHeroesImages/fox.png": 5840,
	"./ultimateHeroesImages/gamewatch.png": 7484,
	"./ultimateHeroesImages/ganon.png": 6618,
	"./ultimateHeroesImages/greninja.png": 3851,
	"./ultimateHeroesImages/iceclimbers.png": 9011,
	"./ultimateHeroesImages/ike.png": 9178,
	"./ultimateHeroesImages/jigglypuff.png": 7510,
	"./ultimateHeroesImages/kirby.png": 4754,
	"./ultimateHeroesImages/link.png": 3863,
	"./ultimateHeroesImages/lucario.png": 606,
	"./ultimateHeroesImages/lucas.png": 3207,
	"./ultimateHeroesImages/luciana.png": 3390,
	"./ultimateHeroesImages/luigi.png": 8693,
	"./ultimateHeroesImages/mac.png": 6590,
	"./ultimateHeroesImages/mario.png": 3955,
	"./ultimateHeroesImages/marth.png": 7715,
	"./ultimateHeroesImages/megaman.png": 1273,
	"./ultimateHeroesImages/metaknight.png": 6499,
	"./ultimateHeroesImages/mewtwo.png": 7702,
	"./ultimateHeroesImages/ness.png": 4950,
	"./ultimateHeroesImages/olimar.png": 4989,
	"./ultimateHeroesImages/pacman.png": 7451,
	"./ultimateHeroesImages/palutena.png": 7969,
	"./ultimateHeroesImages/peach.png": 2268,
	"./ultimateHeroesImages/pichu.png": 4426,
	"./ultimateHeroesImages/pika.png": 8046,
	"./ultimateHeroesImages/pit.png": 2432,
	"./ultimateHeroesImages/pokemontrainer.png": 445,
	"./ultimateHeroesImages/rob.png": 1622,
	"./ultimateHeroesImages/robin.png": 863,
	"./ultimateHeroesImages/rosalina.png": 4512,
	"./ultimateHeroesImages/roy.png": 5477,
	"./ultimateHeroesImages/ryu.png": 1471,
	"./ultimateHeroesImages/samus.png": 2546,
	"./ultimateHeroesImages/sheik.png": 8173,
	"./ultimateHeroesImages/shulk.png": 6702,
	"./ultimateHeroesImages/snake.png": 5095,
	"./ultimateHeroesImages/sonic.png": 9171,
	"./ultimateHeroesImages/toonlink.png": 9755,
	"./ultimateHeroesImages/unpicked_icon.png": 9388,
	"./ultimateHeroesImages/villager.png": 8373,
	"./ultimateHeroesImages/wario.png": 4065,
	"./ultimateHeroesImages/wiitrainer.png": 8299,
	"./ultimateHeroesImages/wolf.png": 5559,
	"./ultimateHeroesImages/yoshi.png": 2945,
	"./ultimateHeroesImages/younglink.png": 3055,
	"./ultimateHeroesImages/zelda.png": 7823,
	"./ultimateHeroesImages/zerosamus.png": 6416,
	"./useHeroes": 3444,
	"./useHeroes.tsx": 3444,
	"draft/heroes/heroImage": 3866,
	"draft/heroes/heroImage.tsx": 3866,
	"draft/heroes/meleeHeroes": 3130,
	"draft/heroes/meleeHeroes.json": 3130,
	"draft/heroes/meleeHeroesImages/bowser.png": 2094,
	"draft/heroes/meleeHeroesImages/cf.png": 9767,
	"draft/heroes/meleeHeroesImages/dk.png": 4467,
	"draft/heroes/meleeHeroesImages/doppelganger.png": 2508,
	"draft/heroes/meleeHeroesImages/drmario.png": 620,
	"draft/heroes/meleeHeroesImages/falco.png": 1233,
	"draft/heroes/meleeHeroesImages/fox.png": 3249,
	"draft/heroes/meleeHeroesImages/ganon.png": 3111,
	"draft/heroes/meleeHeroesImages/iceclimbers.png": 8678,
	"draft/heroes/meleeHeroesImages/kirby.png": 4459,
	"draft/heroes/meleeHeroesImages/link.png": 7160,
	"draft/heroes/meleeHeroesImages/logo.png": 6693,
	"draft/heroes/meleeHeroesImages/luigi.png": 7208,
	"draft/heroes/meleeHeroesImages/mario.png": 8090,
	"draft/heroes/meleeHeroesImages/marth.png": 5086,
	"draft/heroes/meleeHeroesImages/mewtwo.png": 437,
	"draft/heroes/meleeHeroesImages/mrgame.png": 9396,
	"draft/heroes/meleeHeroesImages/ness.png": 1605,
	"draft/heroes/meleeHeroesImages/peach.png": 4433,
	"draft/heroes/meleeHeroesImages/pichu.png": 543,
	"draft/heroes/meleeHeroesImages/pika.png": 7145,
	"draft/heroes/meleeHeroesImages/puff.png": 2797,
	"draft/heroes/meleeHeroesImages/roy.png": 7988,
	"draft/heroes/meleeHeroesImages/samus.png": 1027,
	"draft/heroes/meleeHeroesImages/sheik.png": 4440,
	"draft/heroes/meleeHeroesImages/unpicked_icon.png": 8233,
	"draft/heroes/meleeHeroesImages/yoshi.png": 6600,
	"draft/heroes/meleeHeroesImages/younglink.png": 9078,
	"draft/heroes/meleeHeroesImages/zelda.png": 7250,
	"draft/heroes/ultimateHeroes": 8929,
	"draft/heroes/ultimateHeroes.json": 8929,
	"draft/heroes/ultimateHeroesImages/bayonetta.png": 5502,
	"draft/heroes/ultimateHeroesImages/bowser.png": 4085,
	"draft/heroes/ultimateHeroesImages/bowserjr.png": 7105,
	"draft/heroes/ultimateHeroesImages/cf.png": 1504,
	"draft/heroes/ultimateHeroesImages/cloud.png": 4612,
	"draft/heroes/ultimateHeroesImages/corrin.png": 1916,
	"draft/heroes/ultimateHeroesImages/darkpit.png": 140,
	"draft/heroes/ultimateHeroesImages/dedede.png": 1310,
	"draft/heroes/ultimateHeroesImages/diddy.png": 3585,
	"draft/heroes/ultimateHeroesImages/donkeykong.png": 168,
	"draft/heroes/ultimateHeroesImages/doppelganger.png": 5271,
	"draft/heroes/ultimateHeroesImages/drmario.png": 8321,
	"draft/heroes/ultimateHeroesImages/duckhunt.png": 3127,
	"draft/heroes/ultimateHeroesImages/falco.png": 708,
	"draft/heroes/ultimateHeroesImages/fox.png": 5840,
	"draft/heroes/ultimateHeroesImages/gamewatch.png": 7484,
	"draft/heroes/ultimateHeroesImages/ganon.png": 6618,
	"draft/heroes/ultimateHeroesImages/greninja.png": 3851,
	"draft/heroes/ultimateHeroesImages/iceclimbers.png": 9011,
	"draft/heroes/ultimateHeroesImages/ike.png": 9178,
	"draft/heroes/ultimateHeroesImages/jigglypuff.png": 7510,
	"draft/heroes/ultimateHeroesImages/kirby.png": 4754,
	"draft/heroes/ultimateHeroesImages/link.png": 3863,
	"draft/heroes/ultimateHeroesImages/lucario.png": 606,
	"draft/heroes/ultimateHeroesImages/lucas.png": 3207,
	"draft/heroes/ultimateHeroesImages/luciana.png": 3390,
	"draft/heroes/ultimateHeroesImages/luigi.png": 8693,
	"draft/heroes/ultimateHeroesImages/mac.png": 6590,
	"draft/heroes/ultimateHeroesImages/mario.png": 3955,
	"draft/heroes/ultimateHeroesImages/marth.png": 7715,
	"draft/heroes/ultimateHeroesImages/megaman.png": 1273,
	"draft/heroes/ultimateHeroesImages/metaknight.png": 6499,
	"draft/heroes/ultimateHeroesImages/mewtwo.png": 7702,
	"draft/heroes/ultimateHeroesImages/ness.png": 4950,
	"draft/heroes/ultimateHeroesImages/olimar.png": 4989,
	"draft/heroes/ultimateHeroesImages/pacman.png": 7451,
	"draft/heroes/ultimateHeroesImages/palutena.png": 7969,
	"draft/heroes/ultimateHeroesImages/peach.png": 2268,
	"draft/heroes/ultimateHeroesImages/pichu.png": 4426,
	"draft/heroes/ultimateHeroesImages/pika.png": 8046,
	"draft/heroes/ultimateHeroesImages/pit.png": 2432,
	"draft/heroes/ultimateHeroesImages/pokemontrainer.png": 445,
	"draft/heroes/ultimateHeroesImages/rob.png": 1622,
	"draft/heroes/ultimateHeroesImages/robin.png": 863,
	"draft/heroes/ultimateHeroesImages/rosalina.png": 4512,
	"draft/heroes/ultimateHeroesImages/roy.png": 5477,
	"draft/heroes/ultimateHeroesImages/ryu.png": 1471,
	"draft/heroes/ultimateHeroesImages/samus.png": 2546,
	"draft/heroes/ultimateHeroesImages/sheik.png": 8173,
	"draft/heroes/ultimateHeroesImages/shulk.png": 6702,
	"draft/heroes/ultimateHeroesImages/snake.png": 5095,
	"draft/heroes/ultimateHeroesImages/sonic.png": 9171,
	"draft/heroes/ultimateHeroesImages/toonlink.png": 9755,
	"draft/heroes/ultimateHeroesImages/unpicked_icon.png": 9388,
	"draft/heroes/ultimateHeroesImages/villager.png": 8373,
	"draft/heroes/ultimateHeroesImages/wario.png": 4065,
	"draft/heroes/ultimateHeroesImages/wiitrainer.png": 8299,
	"draft/heroes/ultimateHeroesImages/wolf.png": 5559,
	"draft/heroes/ultimateHeroesImages/yoshi.png": 2945,
	"draft/heroes/ultimateHeroesImages/younglink.png": 3055,
	"draft/heroes/ultimateHeroesImages/zelda.png": 7823,
	"draft/heroes/ultimateHeroesImages/zerosamus.png": 6416,
	"draft/heroes/useHeroes": 3444,
	"draft/heroes/useHeroes.tsx": 3444
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8971;